module.exports = __webpack_public_path__ + "static/media/banner_bg.2274af15.svg";